import Toast from 'honeydew/Toast';
import useGlobalStore from 'hooks/useGlobalStore';

/**
 * GwpErrorToast - Global toast for Gift With Purchase add failures
 * Should be rendered at a layout level (e.g., ShopLayout) to ensure visibility
 * across all surfaces where GWP items can be added (storefront, PDP, cart).
 *
 * @returns {JSX.Element} Toast component for GWP errors
 */
function GwpErrorToast() {
    const { gwpErrorToast, setGwpErrorToast } = useGlobalStore();

    const handleClose = (_, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setGwpErrorToast(false);
    };

    return (
        <Toast
            open={gwpErrorToast}
            handleClose={handleClose}
            copy="There was an issue redeeming your gift. Please refresh the page and try again."
        />
    );
}

export default GwpErrorToast;
